export default function (key) {
  const config = useRuntimeConfig().public
  const isProd = config.environment == 'production' || config.environment == 'LIVE';

  if (config.debugEnabled && !isProd) {
    console.log(`Environment Variable ${key} accessed:`, config[key])
  }

  return config[key] || config.public && config.public[key] || null
}
